export const formSettings = {
  buttonSettings: {
    showCancel: false,
    showNext: true,
    showPrevious: true,
    showSubmit: true,
  },
  noAlerts: true,
};
